import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useImplantacaoOutletContext } from 'pages/Implantacao'
import { useParams } from 'react-router-dom'
import { saldoHoras } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirImplantacao() {
    const { id } = useParams()
    const { data } = useImplantacaoOutletContext()
    const implantacao = data?.find(item => Number(item.id) === Number(id))

    const { mutateAsync, isLoading } = saldoHoras.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!implantacao) return null

    const handleSubmit = () =>
        mutateAsync(implantacao.id, {
            onSuccess: () => {
                toast.success('Implantação excluída com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            width="auto"
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['delete', 'ImplantaçãoDoBancoDeHoras'])}
        >
            <Dialog.Content>
                <span>
                    Realmente deseja excluir a implantação de{' '}
                    <strong>{implantacao.horasExtras}</strong> horas extras e{' '}
                    <strong>{implantacao.faltas}</strong> faltas?
                </span>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
